export const APP_TIME_ZONE = 'America/Mexico_City'

export function localDateKey(date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date)
  const value = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value ?? ''
  return `${value('year')}-${value('month')}-${value('day')}`
}

export function weekdayInMexicoCity(date = new Date()): number {
  return new Date(`${localDateKey(date)}T12:00:00Z`).getUTCDay()
}

export function longLocalDate(date = new Date()): string {
  return new Intl.DateTimeFormat('es-MX', {
    timeZone: APP_TIME_ZONE,
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(date).toUpperCase()
}

export function daysBetween(start: string, end: string): number {
  if (!start || !end) return 0
  const startMs = Date.parse(`${start}T12:00:00Z`)
  const endMs = Date.parse(`${end}T12:00:00Z`)
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return 0
  return Math.max(0, Math.floor((endMs - startMs) / 86_400_000))
}

export function dietDayNumber(start: string, today = localDateKey()): number {
  return start ? daysBetween(start, today) + 1 : 0
}

export function shortDateKey(value: string): string {
  return new Intl.DateTimeFormat('es-MX', { day: 'numeric', month: 'short' }).format(new Date(`${value}T12:00:00Z`))
}
